module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection-container start-xs",
    class: {
      'live-font': _vm.activityType === 'live'
    }
  }, [_c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n    Assessment\n    "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.assessment_description),
      expression: "assessment_description"
    }],
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "radio-button-container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 10px 10px 0px"
    }
  }, [_c('pl-radio', {
    attrs: {
      "value": false
    },
    model: {
      value: (_vm.assessment_status),
      callback: function($$v) {
        _vm.assessment_status = $$v
      },
      expression: "assessment_status"
    }
  }), _vm._v(" "), _c('span', [_vm._v("No Assessment")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 10px 10px 0px"
    }
  }, [_c('pl-radio', {
    attrs: {
      "value": true
    },
    model: {
      value: (_vm.assessment_status),
      callback: function($$v) {
        _vm.assessment_status = $$v
      },
      expression: "assessment_status"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Teacher can provide assessment with points")])], 1)]), _vm._v(" "), (_vm.getCurrentRT.is_sandbox) ? _c('div', {
    staticClass: "italics pl-caption ma4"
  }, [_vm._v("\n    Assessment settings can be managed in your RoundTable, however these\n    options are locked for this demo.\n  ")]) : _vm._e(), _vm._v(" "), (_vm.assessment_status) ? _c('div', {
    class: {
      hide: _vm.getCurrentRT.is_sandbox
    }
  }, [(_vm.activityType === 'written') ? _c('div', {
    staticClass: "pl-subheading",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_vm._v("\n      Max Score\n\n      "), _c('toggle-button', {
    staticClass: "mh3",
    attrs: {
      "value": !!_vm.getCurrentRT.point_cap,
      "labels": false,
      "color": "#72ccd7"
    },
    on: {
      "change": _vm.toggleCriteriaScale
    }
  }), _vm._v(" "), (!_vm.getCurrentRT.is_sandbox) ? _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.scale_description),
      expression: "scale_description"
    }],
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.point_scale !== null) ? _c('div', {
    staticClass: "mv3",
    staticStyle: {
      "margin-left": "6px",
      "display": "flex"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": Number(_vm.point_scale) === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.point_scale -= 1
      }
    }
  }, [_c('i', {
    staticClass: "chevron clickable fa fa-chevron-left"
  })]), _vm._v(" "), _c('pl-input', {
    staticStyle: {
      "width": "50px",
      "height": "23px",
      "text-align": "center",
      "display": "inline-block"
    },
    attrs: {
      "centeredText": true,
      "error": _vm.point_scale === ''
    },
    on: {
      "input": _vm.inputed
    },
    model: {
      value: (_vm.point_scale),
      callback: function($$v) {
        _vm.point_scale = $$v
      },
      expression: "point_scale"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.point_scale) + "\n        ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "display": "inline-block"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addPoint.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "chevron clickable fa fa-chevron-right"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "point-selection-container"
  }, [_c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("Criteria")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "individual-points-container"
  }, _vm._l((_vm.available_point_types), function(point_type, index) {
    return _c('div', {
      key: (index + "-" + (point_type.title)),
      staticClass: "individual-point-selection flex middle-xs",
      class: {
        'selected-description': _vm.untruncated_index === index
      }
    }, [_c('pl-checkbox', {
      staticClass: "col-xs-1",
      attrs: {
        "value": point_type.tag
      },
      model: {
        value: (_vm.selected_points),
        callback: function($$v) {
          _vm.selected_points = $$v
        },
        expression: "selected_points"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "no-padding point-type-text col-xs-3"
    }, [_vm._v("\n            " + _vm._s(_vm._f("truncate")(point_type.title, 25)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "clickable",
      class: [{
          'truncate-text': _vm.untruncated_index !== index
        },
        point_type.is_custom ? 'col-xs-7' : 'col-xs-8' ],
      on: {
        "click": function($event) {
          _vm.untruncated_index = _vm.untruncated_index === index ? -1 : index
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.formatPointDescription(point_type)) + "\n          ")]), _vm._v(" "), (point_type.is_custom) ? _c('div', {
      staticClass: "clickable col-xs-1"
    }, [_c('pl-menu', {
      attrs: {
        "menuSize": 2,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fas fa-ellipsis-v"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.showPointCreationModal(point_type)
        }
      }
    }, [_c('span', [_vm._v("Edit")])]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.deletePoint(point_type)
        }
      }
    }, [_c('span', [_vm._v("Delete")])])])], 1)], 1) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "new-point-button clickable row center-xs middle-xs no-padding",
    on: {
      "click": _vm.showPointCreationModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Create Assessment Point\n    ")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sticky-button-row row middle-xs between-xs no-margin"
  }, [_c('span', {
    staticClass: "col-xs-8"
  }, [(_vm.assessment_status) ? _c('span', [(_vm.activityType === 'written') ? _c('span', [_vm._v("\n          You have Selected " + _vm._s(_vm.selected_points.length) + " assessment types\n        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.user_has_changed_assessment_information) ? _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": _vm.activityType === 'verbal'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateAssessmentInformation.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Save Changes\n    ")]) : _c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('closeTab')
      }
    }
  }, [_vm._v(" Close ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "individual-point-selection row middle-xs around-xs no-margin",
    staticStyle: {
      "color": "#808284",
      "font-size": "12px"
    }
  }, [_c('div', {
    staticClass: "col-xs-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "no-padding point-type-text col-xs-3"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_vm._v("Description")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-cebcffda!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/assessmentSettingsTab.vue
// module id = 1312
// module chunks = 61